import type { TableRowCellSlot } from '../types/Table.type'

export function createSlotCell(cell: TableRowCellSlot): HTMLTableCellElement {
  const td = document.createElement('td')
  td.part = 'cell'
  const slotElement = document.createElement('slot')
  const slotCell = cell as TableRowCellSlot
  const sanitizedSlotName = slotCell.slotName
    ? slotCell.slotName.replace(/[^a-zA-Z0-9\-_]/g, '')
    : ''
  slotElement.name = sanitizedSlotName
  td.appendChild(slotElement)
  return td
}
